import { render, staticRenderFns } from "./ItemForJournal.vue?vue&type=template&id=8a683d42&"
import script from "./ItemForJournal.vue?vue&type=script&lang=js&"
export * from "./ItemForJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports